import React from "react";
import HOC from "../../../components/HOC";
import ReturWarehouseList from "../../../components/screen/centralWarehouse/returWarehouse/ReturWarehouseList";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const ReturnWarehouseListPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Retur to Warehouse"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReturWarehouseList />
          </ThemeProvider>
        }
        pageRole={36}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(ReturnWarehouseListPage);
